import React from 'react';
import { Trash2, GripVertical } from 'lucide-react';

function QuestionDisplay({ 
  question, 
  index, 
  answers, 
  handleInputChange, 
  isAdmin = false, // determines if we show admin controls
  onDeleteClick,
  dragHandleProps,
  provided 
}) {
  const { id, text, type, options } = question;

  const renderInput = () => {
    switch (type) {
      case 'numeric':
        return (
          <input
            type="number"
            value={answers[id] || ''}
            onChange={(e) => handleInputChange(index, e.target.value, type, id)}
            className="w-full p-2 border rounded"
          />
        );

      case 'short-text':
        return (
          <input
            type="text"
            value={answers[id] || ''}
            onChange={(e) => handleInputChange(index, e.target.value, type, id)}
            className="w-full p-2 border rounded"
          />
        );

      case 'long-text':
        return (
          <textarea
            value={answers[id] || ''}
            onChange={(e) => handleInputChange(index, e.target.value, type, id)}
            className="w-full p-2 border rounded min-h-[100px] resize-y"
            rows={4}
          />
        );

      case 'multiple-choice':
        return (
          <div className="space-y-2">
            {options.map((option, optionIndex) => (
              <div key={optionIndex} className="flex items-center">
                <input
                  type="radio"
                  name={`question-${id}`}
                  value={option}
                  checked={answers[id] === option}
                  onChange={(e) => handleInputChange(index, e.target.value, type, id)}
                  className="mr-2"
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
        );

      case 'checkbox-list':
        return (
          <div className="space-y-2">
            {options.map((option, optionIndex) => (
              <div key={optionIndex} className="flex items-center">
                <input
                  type="checkbox"
                  value={option}
                  checked={!!((answers[id] || {})[option])}
                  onChange={(e) => handleInputChange(index, e.target.value, type, id)}
                  className="mr-2"
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  const questionContent = (
    <>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">
          {index + 1}. {text}
        </h3>
        {isAdmin && (
          <div className="flex items-center gap-2">
            <button
              onClick={() => onDeleteClick(index)}
              className="p-1 hover:bg-gray-100 rounded"
            >
              <Trash2 className="w-5 h-5 text-gray-500" />
            </button>
            <div {...dragHandleProps} className="cursor-grab">
              <GripVertical className="w-5 h-5 text-gray-500" />
            </div>
          </div>
        )}
      </div>
      {renderInput()}
    </>
  );

  // If in admin mode and provided is available, wrap in draggable div
  return isAdmin && provided ? (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      className="bg-white rounded-lg shadow p-6"
    >
      {questionContent}
    </div>
  ) : (
    <div className="bg-white rounded-lg shadow p-6">
      {questionContent}
    </div>
  );
}

export default QuestionDisplay; 